import React, {Component} from 'react';
import { Row, Col, FormControl } from 'react-bootstrap';
import { Checkbox, Radio } from 'react-icheck';
import PrintPreview from './PrintPreview';
import ReportKKCAllYearIncomeOverview from '../report/ReportKKCAllYearIncomeOverview';
import ReportStore from '../../stores/ReportStore';

const DEFAULT_ITEM_PER_PAGE = 20
class PrintReportKKCAllYearIncomeOverview extends Component {

  constructor(...args){
    super(...args)
    this.state = {loading:false,itemPerPage:DEFAULT_ITEM_PER_PAGE,data:[],dataList:[],report_title:'กำลังดึงข้อมูล..',affiliates:[]}

    var cssPagedMedia = (function() {
      var style = document.createElement('style');
      document.head.appendChild(style);
      return function (rule) {
        style.innerHTML = rule;
      };
    }());

    cssPagedMedia.size = function(size) {
      cssPagedMedia('@page {size: ' + size + '}');
    };
    cssPagedMedia.size('landscape');
  }

  componentDidMount(){
    this.loadData(this.props.year,this.state.itemPerPage)
  }

  loadData(year,itemPerPage) {
    let {dataList} = this.state
    this.setState({loading:true})
    ReportStore.loadReportAllYearIncomeOverview(year,(result)=>{
      dataList = this.getPagination(result.data,itemPerPage)
      this.setState({data:result.data,dataList:dataList,report_title:'ไม่พบข้อมูล',affiliates:result.affiliates})
    })
  }

  getNumberFormat(value) {
    let _val = value===''||value===null||value===undefined||isNaN(value) ? 0 : value
    _val = parseFloat(_val)
    return _val.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
  }

  getTotal() {
    let {data} = this.state
    let sum = 0
    data.forEach(function(item,index) {
      let income = item.income.customer
      if (income===''||income===null||income===undefined||isNaN(income))
        income = 0

      sum += parseFloat(income)
    })

    return sum
  }

  getSummary(key,sub_key) {
    let {data} = this.state
    let sum = 0
    data.forEach(function(item,index) {
      let value = item[key]
      if (key!=='balance')
        value = item[key][sub_key]

      if (value===''||value===null||value===undefined||isNaN(value))
        value = 0

      sum += parseFloat(value)
    })

    return sum  
  }

  renderAffiliates(ditem){
    let {affiliates} = this.state
    return affiliates.map((item,index)=>{
      if(ditem.income[item.affiliates_id]!==undefined){
        return (<td key={index} className='text-right'>{this.getNumberFormat(ditem.income[item.affiliates_id])}</td>)
      }else{
        return (<td  key={index} className='text-right'>0.00</td>)
      }
    })
  }

  renderRowData(_item,_index,length) {
    if (_item.data.length===0) {
      return(<tr><td colSpan={12}>ไม่พบข้อมูล</td></tr>)
    } else {
      return(
        _item.data.map((item,index)=> {
          return(
            <tr key={index}>
              <td className='text-center'>{index+1}</td>
              <td>{index===0?'มกราคม':index===1?'กุมภาพันธ์':index===2?'มีนาคม':index===3?'เมษายน':index===4?'พฤษภาคม':index===5?'มิถุนายน':index===6?'กรกฎาคม':index===7?'สิงหาคม':index===8?'กันยายน':index===9?'ตุลาคม':index===10?'พฤศจิกายน':index===11?'ธันวาคม':''}</td>
              <td className='text-right'>{item.income===undefined||item.income.customer===undefined||item.income.customer===null?'':this.getNumberFormat(item.income.customer)}</td>
              {this.renderAffiliates(item)}
              <td className='text-right'>{item.income===undefined||item.income.amount===undefined||item.income.amount===null?'':this.getNumberFormat(item.income.amount)}</td>
              <td className='text-right'>{item.expense===undefined||item.expense.wage===undefined||item.expense.wage===null?'':this.getNumberFormat(item.expense.wage)}</td>
              <td className='text-right'>{item.expense===undefined||item.expense.part===undefined||item.expense.part===null?'':this.getNumberFormat(item.expense.part)}</td>
              <td className='text-right'></td>
              <td className='text-right'>{item.expense===undefined||item.expense.cash===undefined||item.expense.cash===null?'':this.getNumberFormat(item.expense.cash)}</td>
              <td className='text-right'>{item.expense===undefined||item.expense.amount===undefined||item.expense.amount===null?'':this.getNumberFormat(item.expense.amount)}</td>
              <td className='text-right'>{item.balance===undefined||item.balance===null?'':this.getNumberFormat(item.balance)}</td>
            </tr>
          )
        })  
      )
    }        
  }

  renderTable(item,index,length) {
    let {affiliates} = this.state
    return(
      <div className=''>
        <table className='table table-responsive table-hover table-bordered-solid table-report-kkc-all-year-income-overview table-print-report-kkc-all-year-income-overview'>
          <thead>
            <tr>
              <th colSpan={12+affiliates.length} className='text-center bg-none'>สรุปรายรับรถเข้าซ่อม - ค่าใช้จ่าย {this.props.year}</th>
            </tr>
            <tr>
              <th rowSpan={2} className='text-center bg-none' style={{width:'50px'}}>ลำดับ</th>
              <th className='text-center bg-none' colSpan={2+affiliates.length}>รถเข้าซ่อม</th>
              <th rowSpan={2} className='text-center bg-none' style={{width:'100px'}}>รวมรายได้</th>
              <th className='text-center bg-none' colSpan={4}>คชจ.</th>
              <th rowSpan={2} className='text-center bg-none' style={{width:'100px'}}>รวม คชจ.</th>
              <th className='text-center bg-none'>คงเหลือ</th>
            </tr>
            <tr>
              <th className='text-center bg-none' style={{width:'90px'}}>เดือน</th>
              <th className='text-center bg-none' style={{width:'100px'}}>ในเครือ</th>
              {
                affiliates.map((item,index)=>(
                  <th key={index} className='text-center bg-none' style={{width:'100px'}}>{item.name}</th>
                ))
              }
              <th className='text-center bg-none' style={{width:'100px'}}>ค่าแรง</th>
              <th className='text-center bg-none' style={{width:'100px'}}>อะไหล่ต้นเดือน</th>
              <th className='text-center bg-none' style={{width:'100px'}}>อะไหล่กลางเดือน</th>
              <th className='text-center bg-none' style={{width:'100px'}}>เงินสด</th>
              <th className='text-center bg-none' style={{width:'100px'}}>(รถเข้าซ่อม-คชจ.)</th>
            </tr>
          </thead>
          <tbody>
            {this.renderRowData(item,index,length)}  
          </tbody>
          <tfoot>
            <tr>
              <th className='bg-none'></th>
              <th className='text-center bg-none'>รวมทั้งสิ้น</th>
              <th className='text-right bg-none'>{this.getNumberFormat(this.getTotal())}</th>
              {
                affiliates.map((item,index)=>(                  
                  <th key={index} className='text-right bg-none'>{this.getNumberFormat(this.getSummary('income',item.affiliates_id))}</th>
                ))
              }
              <th className='text-right bg-none'>{this.getNumberFormat(this.getSummary('income','amount'))}</th>
              <th className='text-right bg-none'>{this.getNumberFormat(this.getSummary('expense','wage'))}</th>
              <th className='text-right bg-none'>{this.getNumberFormat(this.getSummary('expense','part'))}</th>
              <th className='text-right bg-none'></th>
              <th className='text-right bg-none'>{this.getNumberFormat(this.getSummary('expense','cash'))}</th>
              <th className='text-right bg-none'>{this.getNumberFormat(this.getSummary('expense','amount'))}</th>
              <th className='text-right bg-none'>{this.getNumberFormat(this.getSummary('balance',''))}</th>
            </tr>
          </tfoot>
        </table>
      </div>
    )      
  }

  renderComponentPage(item,index,length) {
    return(
      <div className='font-print' key={index}>
        <header style={{textAlign:'center',marginBottom:'20px'}}>
          <h2>{this.props.title+' '+this.props.year}</h2>
        </header>
        <div className='font-14'>   
          {this.renderTable(item,index,length)}          
        </div>
      </div>  
    )
  }

  getPagination(data,itemPerPage) {
    let checkRow = 0
    let newData = []
    let allData = []
    let footer = false
    
    data.forEach(function(item,index) {
      if (checkRow<itemPerPage) {
        newData.push(item)
      }
      if (checkRow===itemPerPage-1||index===data.length-1) {
        if (index===data.length-1)
          footer = true
        allData.push({
          data:newData,
          footer:footer
        })
        newData = []
        checkRow = -1
      }
      checkRow++
    })
    
    return allData
  }

  // onRowsPerPageChange(itemPerPage) {
  //   this.setState({itemPerPage:itemPerPage})
  //   this.loadData(this.props.year,itemPerPage)
  // }

  renderNoData() {
    return(
      <div className='font-print'>
        <header className="text-center">
          <h2>{this.state.report_title}</h2>
        </header>
      </div>
    )
  }

  render() {
    let {loading,dataList} = this.state
    let {year,typePrint} = this.props
    year = parseInt(year) + 543

    if (typePrint==='chart') {
      return(
        <PrintPreview 
          loading={loading} 
          size={'landscape'}
          leftBarTitle={this.props.title+' '+this.props.year}
        >
          <ReportKKCAllYearIncomeOverview
            typePrint={'chart'}
            showPrintPreview={true}
            titleBarChat={this.props.title+' '+this.props.year}
            year={year}
          >
          </ReportKKCAllYearIncomeOverview>
        </PrintPreview>
      )
    } else {
      if (dataList.length===0) {
        return(
          <div>
            <PrintPreview 
              loading={loading} 
              size={'landscape'}
              leftBarTitle={this.props.title+' '+this.props.year}
            >
              {this.renderNoData()}
            </PrintPreview>
          </div>
        )
      } else {
        return(
          <div>
            <PrintPreview 
              loading={loading} 
              size={'landscape'}
              leftBarTitle={this.props.title+' '+this.props.year}
            >
              {
                dataList.map((item,index) => {
                  return(
                    this.renderComponentPage(item,index,dataList.length-1)
                  )
                })
              }
            </PrintPreview>
          </div>
        )
      }
    } 
  }

}  

PrintReportKKCAllYearIncomeOverview.defaultProps = {
  title: 'รายงานสรุปรับรถเข้าซ่อม - ค่าใช้จ่ายจริง',  
  mode : '1'
}
export default PrintReportKKCAllYearIncomeOverview;


// WEBPACK FOOTER //
// ./src/view/print/PrintReportKKCAllYearIncomeOverview.js